module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Iron-c80c83ba6cb9dafc92b02cc21135218a.svg";